// 接口
import axios from '@/axios'
import { baseUrl } from '@/axios/baseUrl'
// 获取商品价格
export const getGoodsPrice = (date) => axios.get(baseUrl + '/queapi/price/index_goods_price?time=' + date)
